import Explore from "../components/Explore/Explore";

const ExplorePage = (): JSX.Element => {
  return <Explore />;
};

export default ExplorePage;
